import { retrieveLaunchParams } from "@telegram-apps/sdk";
import { Platform } from "./platform";

type WebAppWithStartParam = {
    initData?: string;
    initDataUnsafe?: { start_param?: string };
};

/**
 * Same as shop `getWebApp()`: Max bridge exposes `window.WebApp`.
 */
const getWebApp = (): WebAppWithStartParam | undefined =>
    (window as Window & { WebApp?: WebAppWithStartParam }).WebApp;

/**
 * Reads the raw mini-app start payload (e.g. `ref44-yclid123`).
 * Mirrors shop `platform/deeplink.ts` → `getRawStartParam`.
 */
const getRawStartParam = (): string | undefined => {
    try {
        const startParam = retrieveLaunchParams().tgWebAppStartParam;
        if (startParam) {
            return startParam;
        }
    }
    catch {
        // not a Telegram mini app environment
    }

    const webApp = getWebApp();
    const fromUnsafe = webApp?.initDataUnsafe?.start_param;
    if (fromUnsafe) {
        return fromUnsafe;
    }

    const initData = webApp?.initData;
    if (initData) {
        try {
            return new URLSearchParams(decodeURIComponent(initData)).get("start_param") ?? undefined;
        }
        catch {
            return new URLSearchParams(initData).get("start_param") ?? undefined;
        }
    }

    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("tgWebAppStartParam") ?? searchParams.get("WebAppStartParam") ?? undefined;
};

/**
 * @param _platform Kept for call-site compatibility; sources are platform-agnostic like in shop.
 */
export const resolveStartParam = (_platform: Platform): string | undefined => {
    return getRawStartParam();
};
